// Catalog errors, shared by the catalog's command groups.
import { z } from 'zod';
import { defineError } from '../../define/errors.ts';

/** A catalog save core refuses (L104: a True Margin location cannot hold a tax-inclusive product). */
export const CatalogInvalid = defineError({
  code: 'catalog.invalid', httpStatus: 422, message: 'errors.catalog.invalid', retryable: false,
  details: z.object({ rule: z.string(), field: z.string().optional(), productIds: z.array(z.string()).optional() }),
});

export const CatalogEntityNotFound = defineError({
  code: 'catalog.not_found', httpStatus: 404, message: 'errors.catalog.not_found', retryable: false,
  details: z.object({ entity: z.string(), id: z.string() }),
});


/**
 * One category or item of a catalog.upsertMenu call refused, so nothing of the call was written: which one (`at`, as
 * `categories.N` or `products.N`, with its id and name), and its own refusal (the single command's code, the field, and
 * the reason when it gave one).
 */
export const MenuItemRefused = defineError({
  code: 'catalog.menu_item_refused', httpStatus: 422, message: 'errors.catalog.menu_item_refused', retryable: false,
  details: z.object({
    at: z.string(), kind: z.enum(['category', 'modifierGroup', 'product', 'variant']), id: z.string(), name: z.string().nullable(),
    code: z.string(), field: z.string().nullable(), reason: z.string().nullable(),
  }),
});

/**
 * A row of a catalog.upsertMenu call named the version it was read at (`expectedVersion`), and the row has moved on since
 * (ops plan 2026-10-19-launchpad-bulk-mode §4.6 item 2), so nothing of the call was written: which row (`at`, its kind
 * and id) and the version it is at now (0 when it doesn't exist). Launchpad's List mode re-reads and applies its own
 * change again by itself.
 */
export const ChangedSince = defineError({
  code: 'catalog.changed_since', httpStatus: 409, message: 'errors.catalog.changed_since', retryable: false,
  details: z.object({ at: z.string(), kind: z.enum(['category', 'modifierGroup', 'product', 'variant']), id: z.string(), version: z.int().nonnegative() }),
});
